




export default function Footer(props) {
	return (
		<section className="row">       
			<div className="explore">
				<div className="container">
					<div className="row">
						<div className="col-12">
							<h3>Explore more from BlackRock</h3>
							<div className="links-container">
								<div className="links">
									<span className="cta-box">
										<div className="cta-container-box">
											<a href="https://www.blackrock.com/us/financial-professionals/investment-strategies/preparing-portfolios" target="_blank"  className="cta link"> 
												<span className="label">
													<span className="icon fa fa-angle-right" aria-hidden="true"></span>
													<span>Redesign portfolios</span>
												</span>
											</a> 
										</div>
									</span>
									<span className="cta-box">
										<div className="cta-container-box">
											<a href="https://www.blackrock.com/us/financial-professionals/investment-strategies/preparing-portfolios/bonds" target="_blank"  className="cta link"> 
												<span className="label">
													<span className="icon fa fa-angle-right" aria-hidden="true"></span>
													<span>Barbell your bonds</span>
												</span>
											</a> 
										</div>
									</span>
									<span className="cta-box">
										<div className="cta-container-box">
											<a href="https://www.blackrock.com/us/financial-professionals/products/bond-etfs " target="_blank" className="cta link"> 
												<span className="label">
													<span className="icon fa fa-angle-right" aria-hidden="true"></span>
													<span>Invest with bond ETFs</span>
												</span>
											</a> 
										</div>
									</span>
								</div>
							</div>
                    	</div>
               		</div>
            	</div>
        	</div>
        </section>
	)
}